import { HTTP_TYPES } from '@/lib/enums'
import api from '@/api/api'

const response = {
  async getReviewById(review_uuid: string): Promise<any> {
    // from_date: datetime
    // to_date: datetime
    // type: string

    return await api(
      HTTP_TYPES.GET,
      `${import.meta.env.VITE_DEPOT_API_REVIEWS}/review/${review_uuid}`,
    )
  }
}

export default response
